import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: '100%',
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    backgroundColor: '#004B2B',
    borderBottom: '1px solid rgba(255, 255, 255, 0.16)',
  },
  link: {
    width: '100%',
    height: '100%',
    paddingLeft: 20,
    paddingRight: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
  },
  logoOpen: {
    height: 64,
    width: 'auto',
    maxWidth: sidebarConfig.drawerWidthOpen - 40,
    objectFit: 'contain',
  },
  logoClosed: {
    height: 30,
    width: 30,
    objectFit: 'contain',
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        <img
          src="/Mainnavlogo.png"
          alt="Acme API Portal Logo"
          className={isOpen ? classes.logoOpen : classes.logoClosed}
        />
      </Link>
    </div>
  );
};